import posthog from 'posthog-js';

// Analytics helpers (PostHog EU). Everything here is a no-op unless we're on the
// live memocal.app site — same guard as index.js — so dev/test never pollute the
// product data, and a missing/blocked PostHog can never break the app.
const LIVE = typeof window !== 'undefined'
  && /(^|\.)memocal\.app$/.test(window.location.hostname);

// Track a named product event (for funnels: signup → first event, etc.).
// Never send personal content (event titles, notes) — only the ACTION + safe
// metadata like method/priority. See the PostHog guide on the Desktop.
export function track(event, props) {
  if (!LIVE) return;
  try { posthog.capture(event, props); } catch (_) {}
}

// Link the anonymous visitor to the logged-in person, so their pre-login
// pageviews join up in the funnel. id must be the stable user id (not email).
export function identifyUser(id, props) {
  if (!LIVE || !id) return;
  try { posthog.identify(String(id), props); } catch (_) {}
}
